// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"8d3b9f92","534":"dc71b608","597":"a679b0d4"}[chunkId] + ".chunk.css";
};